import {
  GRID_CHECKBOX_SELECTION_FIELD,
  GRID_TREE_DATA_GROUPING_FIELD,
} from "@mui/x-data-grid-pro";
import { useProfileStore, useSessionStore } from "../../stores/UserStore";
import { filterNumberTypes } from "../../components/Filter/filterSettings";

export const defaultPageSize = 15;

export const defaultButtonType = "outline";

function getOrder({ pageOrderName, desiredOrder, listId }) {
  const profile = useProfileStore.getState().profile;
  let order =
    profile?.saved_order?.[pageOrderName]?.order_columns || desiredOrder;

  if (listId) {
    const savedListOrder =
      profile.saved_order
        ?.contact_list_fetch_contacts_order_by_contact_list_id?.[listId];

    if (savedListOrder) {
      order = savedListOrder.order_columns;
    }
  }

  if (order) {
    return order.map((x) => x.toString());
  }
  return [];
}
function getSizes({ pageOrderName, listId }) {
  const profile = useProfileStore.getState().profile;
  let size = {};
  let saved_size = profile?.saved_order?.[pageOrderName]?.size_columns;

  if (listId) {
    const savedListOrder =
      profile.saved_order
        ?.contact_list_fetch_contacts_order_by_contact_list_id?.[listId];

    if (savedListOrder) {
      saved_size = savedListOrder.size_columns;
    }
  }

  if (saved_size) {
    Object.keys(saved_size).forEach((key) => {
      if (key === "name") {
        size[key] = {
          width: saved_size[key],
          flex: false,
        };
      } else {
        size[key] = {
          width: saved_size[key],
        };
      }
    });
  }

  return size;
}
function getVisibility({ pageOrderName, columns, listId }) {
  const user_switch = useSessionStore.getState().user_switch;
  const profile = useProfileStore.getState().profile;
  let hidden_columns = profile?.saved_order?.[pageOrderName]?.hidden_columns;
  let order_columns = profile?.saved_order?.[pageOrderName]?.order_columns;

  if (listId) {
    const savedListOrder =
      profile.saved_order
        ?.contact_list_fetch_contacts_order_by_contact_list_id?.[listId];

    if (savedListOrder) {
      hidden_columns = savedListOrder.hidden_columns;
      order_columns = savedListOrder.order_columns;
    }
  }

  let model = {
    id: user_switch
      ? true
      : hidden_columns
        ? !hidden_columns?.includes("id")
        : false,
  };

  if (
    listId &&
    pageOrderName === "contact_list_fetch_contacts_order_google_maps"
  ) {
    model["2"] = false;
    model["3"] = false;
    model["4"] = false;
    model["5"] = false;
    model["11"] = false;
  }

  if (hidden_columns) {
    [{ field: "__check__" }, ...columns].forEach((column) => {
      if (hidden_columns.includes(column.field)) {
        model[column.field] = false;
      } else {
        if (column.field === "id") {
          return (model[column.field] = user_switch
            ? true
            : order_columns
              ? true
              : false);
        }
        return (model[column.field] = true);
      }
    });
  }

  return { ...model, id: user_switch ? true : model.id };
}
function getInitialFilter({
  pageName,
  columns,
  defaultSearch,
  defaultFilter,
  isClient,
}) {
  const profile = useProfileStore.getState().profile;
  let pinnedFilter = profile?.saved_filters?.[pageName]?.find((x) => x.pinned);

  // Contact ID filter
  let params = new URLSearchParams(location.search);
  let paramsFilter = params.get("filter");
  if (paramsFilter) {
    let parsed = JSON.parse(paramsFilter);

    const newFilter = {
      items:
        parsed?.values?.map((val, index) => ({
          field: val.field_name,
          value: val.value?.toString(),
          operator: val.type,
          id: index.toString(),
        })) || [],
      logicOperator: parsed?.mode || "and",
      quickFilterValues: defaultSearch?.split(" ") || [""],
    };

    return newFilter;
  }

  // Pinned filter
  if (pinnedFilter || defaultFilter) {
    let f = defaultFilter || pinnedFilter?.filter;

    const savedFilter = {
      mode: f?.mode,
      values: f?.values?.map((item) => {
        let isNumber =
          columns.find((x) => x.field === item.field_name)?.type === "number";

        return {
          ...item,
          type:
            isNumber && isClient
              ? Object.keys(filterNumberTypes).find(
                  (key) => filterNumberTypes[key] === item.type,
                )
              : item?.type,
        };
      }),
    };

    const newFilter = {
      items:
        savedFilter?.values?.map((val, index) => ({
          field: val.field_name,
          value: val.value,
          operator: val.type,
          id: index.toString(),
        })) || [],
      logicOperator: savedFilter?.mode || "and",
      quickFilterValues: defaultSearch?.split(" ") || [""],
    };

    return newFilter;
  }

  return {
    items: [],
    logicOperator: "and",
    quickFilterValues: defaultSearch?.split(" ") || [""],
  };
}

export function getDefaultDensity() {
  const profile = useProfileStore.getState().profile;

  return profile?.table_density || "standard";
}

export const initialTableState = ({
  pinnedLeft,
  pinnedRight,
  disablePerPage,
  defaultPerPage,
  pageName,
  pageOrderName,
  columns,
  desiredOrder,
  desiredVisibleColumns,
  defaultSearch,
  defaultFilter,
  defaultSort,
  defaultColumnVisibilityModel,
  isClient,
  listId,
}) => {
  return {
    pagination: {
      paginationModel: {
        pageSize: disablePerPage
          ? defaultPerPage || 100
          : defaultPerPage || defaultPageSize,
      },
    },
    pinnedColumns: {
      left: pinnedLeft || [
        GRID_CHECKBOX_SELECTION_FIELD,
        GRID_TREE_DATA_GROUPING_FIELD,
      ],
      right: pinnedRight || ["actions"],
    },
    columns: {
      columnVisibilityModel:
        defaultColumnVisibilityModel ||
        getVisibility({
          pageOrderName,
          columns,
          desiredVisibleColumns,
          listId,
        }),
      orderedFields: getOrder({ pageOrderName, desiredOrder, listId }),
      dimensions: getSizes({ pageOrderName, listId }),
    },
    filter: {
      filterModel: getInitialFilter({
        pageName,
        columns,
        defaultSearch,
        defaultFilter,
        isClient,
      }),
    },
    sorting: {
      sortModel: defaultSort || [],
    },
  };
};
